/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ValidationFaultPaymentUnavailable } from "./ValidationFaultPaymentUnavailable";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_UNAVAILABLE" = "PAYMENT_UNAVAILABLE"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to validation errors.
 */

// required attributes
const ValidationFaultPaymentUnavailableProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: ValidationFaultPaymentUnavailable
});

// optional attributes
const ValidationFaultPaymentUnavailableProblemJsonO = t.partial({
  title: t.string
});

export const ValidationFaultPaymentUnavailableProblemJson = t.intersection(
  [
    ValidationFaultPaymentUnavailableProblemJsonR,
    ValidationFaultPaymentUnavailableProblemJsonO
  ],
  "ValidationFaultPaymentUnavailableProblemJson"
);

export type ValidationFaultPaymentUnavailableProblemJson = t.TypeOf<
  typeof ValidationFaultPaymentUnavailableProblemJson
>;
